import { createContext, type ReactNode, useContext } from 'react';

const PlatformScopeContext = createContext<string | null>(null);

/**
 * Marca que a arvore de componentes abaixo esta rodando dentro da area do
 * saas admim, reusando a tela do salao apontada para a empresa da propria
 * plataforma. As chamadas de API viram `/api/v1${prefix}/...` em vez de
 * `/api/v1/...` - o resto da tela nao muda uma linha.
 */
export function PlatformScopeProvider({
  prefix,
  children,
}: {
  prefix: string;
  children: ReactNode;
}) {
  return <PlatformScopeContext.Provider value={prefix}>{children}</PlatformScopeContext.Provider>;
}

/** Vazio no salao; `/saas/gestao`, `/saas/financeiro` etc. quando reusada. */
export function usePlatformPrefix(): string {
  return useContext(PlatformScopeContext) ?? '';
}
